import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import { RequirePermissions } from "@/app/router/guards";
import { PermissionCodes } from "@/shared/auth/permissions";
import { LazyPage } from "@/app/router/LazyPage";

const BiProductionPage = lazy(() =>
  import("@/modules/bi").then((m) => ({ default: m.BiProductionPage })),
);
const BiQualityPage = lazy(() =>
  import("@/modules/bi").then((m) => ({ default: m.BiQualityPage })),
);
const BiWarehousePage = lazy(() =>
  import("@/modules/bi").then((m) => ({ default: m.BiWarehousePage })),
);

export const biRoutes: RouteObject[] = [
          {
            element: (
              <RequirePermissions
                codes={[
                  PermissionCodes.BiRead, PermissionCodes.BiProdList, PermissionCodes.BiQcList, PermissionCodes.BiWhList,
                  PermissionCodes.ExeKpiRead,
                ]}
                match="any"
              />
            ),
            children: [
              {
                path: "bi/production",
                element: (
                  <LazyPage>
                    <BiProductionPage />
                  </LazyPage>
                ),
              },
              {
                path: "bi/quality",
                element: (
                  <LazyPage>
                    <BiQualityPage />
                  </LazyPage>
                ),
              },
              {
                path: "bi/warehouse",
                element: (
                  <LazyPage>
                    <BiWarehousePage />
                  </LazyPage>
                ),
              },
            ],
          },
];
